<script setup lang="ts">
  import type { Editor } from '@tiptap/vue-3';

  import { Button } from '@ui/components/button';
  import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
  } from '@ui/components/dropdown-menu';
  import { Tooltip, TooltipContent, TooltipTrigger } from '@ui/components/tooltip';

  const props = defineProps<{
    editor: Editor;
    toggleClass?: string;
  }>();

  const fontSizeOptions = [
    { label: 'Small', value: '10px', style: 'font-size: 10px' },
    { label: 'Normal', value: 'normal', style: 'font-size: 12px' },
    { label: 'Large', value: '16px', style: 'font-size: 16px' },
  ];

  const handleFontSizeChange = (value: string) => {
    if (value === 'normal') {
      props.editor.chain().focus().unsetFontSize().run();
    } else {
      props.editor.chain().focus().setFontSize(value).run();
    }
  };
</script>

<template>
  <Tooltip>
    <TooltipTrigger as-child>
      <DropdownMenu>
        <DropdownMenuTrigger as-child>
          <Button :class="toggleClass" size="icon-sm" type="button" variant="ghost">
            <i class="fa fa-text-size" aria-hidden="true" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent side="top">
          <DropdownMenuItem
            v-for="option in fontSizeOptions"
            :key="option.value"
            :style="option.style"
            @click="handleFontSizeChange(option.value)"
          >
            {{ option.label }}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </TooltipTrigger>
    <TooltipContent side="bottom"> Font Size </TooltipContent>
  </Tooltip>
</template>
